import { useParams } from 'react-router-dom';
import SignaturePadMobileView from './SignaturePadMobileView';
import { isValidRelaySlug } from './signaturePadRelayUtils';

/** Public mobile signing page (no login) — opened from desktop QR scan. */
export default function SignaturePadMobilePage() {
    const { sessionSlug } = useParams();
    const slug = isValidRelaySlug(sessionSlug) ? sessionSlug : null;
    return <SignaturePadMobileView sessionSlug={slug} />;
}
